export default __webpack_public_path__ + "static/media/Stars.9bff5c7d.svg";